export const DISK_SPACE_PATH = "/settings-menu/disk-space";
